module.exports = __webpack_public_path__ + "static/media/fate.05c564b5.jpg";